import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/images/logo-img.png";
import axios from "axios";
import "react-international-phone/style.css";
import "react-phone-input-2/lib/style.css";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Tokenomics from "../../assets/images/Tokenomics_LFCoin.jpg";
import visa from "../../assets/images/visa.svg";
import solanaBuy from "../../assets/images/solanaBuy.png";
import phantom from "../../assets/images/phantom.png";
import moonshoot from "../../assets/images/moonshoot.png";
import CountdownTimer from "../../views/promotional/CountdownTimer/CountdownTimer";
import donut from "../../assets/images/donut.svg";
import bar from "../../assets/images/bar.svg";
import leftBar from "../../assets/images/leftBar.svg";
import rightBar from "../../assets/images/rightBar.svg";
import TableRecord from "./TableRecord";
import Graph from "./Graph";
import Chart from "./Chart";
import { signUpNewsLetter, resetNewsLetterState } from "../../store/reducers/newsLetterSlice";
import Swal from "sweetalert2";

const Content = () => {
  const [tokenAddress, setTokenAddress] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [isAccepted, setIsAccepted] = useState(false);
  const [errorAcceptance, setErrorAcceptance] = useState("");

  const dispatch = useDispatch();
  const { loading:loadindNews, error:errorNews, success, message } = useSelector((state) => state?.signUpNewsLetter);

  const handelWhitepaperOpen = () => {
    // window.open(pdfFile, "_blank");
    window.open("/lfcoin_whitepaper.pdf", "_blank");
  };

  const REACT_APP_EXPLORER_BASE_URL = process.env.REACT_APP_EXPLORER_BASE_URL;
  const REACT_APP_TOKEN_ENVIRONMENT = process.env.REACT_APP_TOKEN_ENVIRONMENT;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 30); // 30 days from now
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(tokenAddress);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {

    }
  };

  useEffect(() => {
    fetchCurrentTokenAddress();
  }, []);

  const fetchCurrentTokenAddress = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/deployment/knowTokenAddress`
      );
      setTokenAddress(response?.data.data?.tokenContractAddress);
    } catch (error) {

    }
  };

  useEffect(() => {
    getResponse();
  }, [loadindNews])
  
  const getResponse = () => {
    if (!loadindNews && success) {
      const successMessage = message || "Successfully signed up for the newslatter.";
      Swal.fire({
        title: "Success!",
        text: successMessage,
        icon: "success",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetNewsLetterState ());
        }
      })
  
      // Reset form fields after success
      setEmail("");
      setIsAccepted(false);
      setErrorEmail("");
      setErrorAcceptance("");
  
    } else if (!loadindNews && errorNews) {
      // Display the error message returned from the API
      const errorMessage = errorNews || "This email is already subscribed for newsletter.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetNewsLetterState());
        }
      })
  
    }
  }
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorEmail("");
    setErrorAcceptance("");
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      // setErrorEmail("Email is required");
      Swal.fire({
        title: "Error",
        text: "Email is required!",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    } else if (!emailPattern.test(email)) {
      Swal.fire({
        title: "Success!",
        text: "Please enter a valid email address!",
        icon: "success",
        confirmButtonText: "Ok",
      });
      // setErrorEmail("Please enter a valid email address");
      // return;
    }
  
    if (!isAccepted) {
      Swal.fire({
        title: "Error",
        text: "You must accept the terms and conditions!",
        icon: "error",
        confirmButtonText: "Ok",
      });
      // setErrorAcceptance("You must accept the terms");
      return;
    }
    // Dispatch the signup action
    dispatch(signUpNewsLetter({ email, is_agree: isAccepted }));
  
  };
  


  return (
    <>
      <div className="top-head-section-new"></div>
      <div className="home-container home-page">
        <div className="container community-counter-section">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 content-counter-sec">
              <div className="lend-cont">
                <CountdownTimer targetDate={targetDate} />
                {/* <div className="community-header-hurry-up join-community-new mb-2"> */}
                  {/* <div className="join-community-line"> Join our community now to claim your airdrop!</div> */}
                  {/* <div className="join-community-line"> Please, Sign Up for the newsletter!</div>
                  <br /> */}
                  {/* <div className="join-us-btn">
                    <Link
                      to="/community/#join-community"
                      className="click-here-btn"
                    >
                      Click Here
                    </Link></div> */}
  <div id="join-community" className="event-signupbox community-page-signuppage">
            <div className="container community-header-hurry-up ">
              <h2>Subscribe for the Newsletter! </h2>
            </div>
            <div className="home-container home-page centercontainer ">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="laker-fan-coin-form event-lakerform">
                  <form onSubmit={handleSubmit}>
                    <h3 className="homepage-signup">Please, Sign Up for the Newsletter</h3>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-box">
                          <label htmlFor="email">
                            Email<span className="color-asterisk">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setErrorEmail("");
                            }}
                            maxLength={40}
                          />
                          <span className="fa-solid fa-envelope field-icon"></span>
                        </div>
                        {errorEmail && (
                          <div className="validation-mess">
                            <p className="text-danger">{errorEmail}</p>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="accept-content">
                          <div className="accept-checkbox">
                            <input
                              type="checkbox"
                              id="acceptance"
                              checked={isAccepted}
                              onChange={(e) => {
                                setIsAccepted(e.target.checked);
                                setErrorAcceptance("");
                              }}
                            />
                          </div>
                          <div>
                            <label htmlFor="acceptance">
                              By joining the LFCoin Community, you agree that $LAL
                              coins are promotional and not linked to any other
                              offers or obligations. They hold no guaranteed value,
                              and $LAL is not liable for any losses or issues
                              arising from receiving or using the coins. No legal
                              claims or recourse will be accepted.
                            </label>
                          </div>
                        </div>
                        {errorAcceptance && (
                          <div className="validation-mess">
                            <p className="text-danger">{errorAcceptance}</p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="cstm-login-btn">
                      <button
                        type="submit"
                        className="btn w-100"
                        disabled={loadindNews}
                      >
                        {loadindNews ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}

                </div>
                <div className="lend-cont-inner">
                  <h2 className="main-top-head">LFCoin ($LAL)</h2>
                  <p>
                    It is a community-driven cryptocurrency built on the Solana
                    blockchain, designed to engage and reward a passionate
                    community of sports fans. By participating in games,
                    activities, and governance, LF Coin offers fans a unique way
                    to celebrate sports fandom.   <Link onClick={handelWhitepaperOpen} className="click-here-btn content-whitepaper">This whitepaper </Link> outlines the
                    technical specifications, tokenomics, and utility of LF
                    Coin, showcasing how the ecosystem operates and benefits
                    holders. LF Coin incorporates limited DAO mechanics, giving
                    token holders basic voting rights on project proposals.
                    Deeper levels of community engagement and governance are
                    unlocked through ownership of our digital membership, which
                    provides access to exclusive decision-making opportunities,
                    events, and other benefits.
                  </p>
                </div>
              </div>
            </div>
          
        </div>
      </div>
      <div class="body__inner-wrapper">
        <div class="marquee">
          <div class="marquee__inner-wrap">
            <div class="marquee__inner">
              <Link
                to="/community"
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <span className="text-block-5 space">
                  Sign up for airdrop &nbsp; &nbsp; Sign up for airdrop &nbsp; &nbsp; Sign up for airdrop

                </span>
                <div class="marquee__img">
                  <div className="trump-t">
                    <Link to="/community">
                      <img
                        src={logo}
                        loading="lazy"
                        alt="Buy $LAL"
                        width="80%"
                      />
                    </Link>
                  </div>
                </div>
                <span className="text-block-5 space">JOIN THE COMMUNITY</span>
                <div class="marquee__img">
                  <div className="trump-t">
                    <Link to="/community">
                      <img
                        src={logo}
                        loading="lazy"
                        alt="Buy $LAL"
                        width="80%"
                      />
                    </Link>
                  </div>
                </div>
                <span className="text-block-5 space">
                  Sign up for airdrop &nbsp; &nbsp; Sign up for airdrop &nbsp; &nbsp; Sign up for airdrop
                </span>
                <div class="marquee__img">
                  <div className="trump-t">
                    <Link to="/community">
                      <img
                        src={logo}
                        loading="lazy"
                        alt="Buy $LAL"
                        width="80%"
                      />
                    </Link>
                  </div>
                </div>
                <span className="text-block-5 space">JOIN THE COMMUNITY</span>
                <div class="marquee__img">
                  <div className="trump-t">
                    <Link to="/community">
                      <img
                        src={logo}
                        loading="lazy"
                        alt="Buy $LAL"
                        width="80%"
                      />
                    </Link>
                  </div>
                </div>
                <span className="text-block-5 space">
                  Sign up for airdrop &nbsp; &nbsp; Sign up for airdrop &nbsp; &nbsp; Sign up for airdrop
                </span>
                <div class="marquee__img">
                  <div className="trump-t">
                    <Link to="/community">
                      <img
                        src={logo}
                        loading="lazy"
                        alt="Buy $LAL"
                        width="80%"
                      />
                    </Link>
                  </div>
                </div>
                <span className="text-block-5 space">JOIN THE COMMUNITY</span>
                <div class="marquee__img">
                  <div className="trump-t">
                    <Link to="/community">
                      <img
                        src={logo}
                        loading="lazy"
                        alt="Buy $LAL"
                        width="80%"
                      />
                    </Link>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <div id="contract-address" className="section-contract-address">
        <div className="container address-copy-boxsection">
          <div className="row">
            <div className="address_copy_bx">
              <h2>Solana Contract Address</h2>
              <div className="copylink_wrp-address">
                <div className="contract_address_text">
                  <div className="div-block">
                    <Tooltip title="Contract Address" arrow>
                      <div className="text-block">CA:</div>
                    </Tooltip>
                  </div>
                  <p className="solana-copyclip_text">{tokenAddress}</p>
                </div>

                <div className="btn_style">
                  <Tooltip title="Copy Address" arrow>
                    <button
                      type="button"
                      className={`address_copy_btn ${isCopied ? "copied" : ""}`}
                      onClick={handleCopy}
                    >
                      {isCopied ? "Copied!" : "Copy Address"}
                    </button>
                  </Tooltip>
                  <Tooltip title="View on Explorer" arrow>
                    <button
                      className="address_copy_btn"
                      onClick={() => window.open(`${REACT_APP_EXPLORER_BASE_URL}address/${tokenAddress}?cluster=${REACT_APP_TOKEN_ENVIRONMENT}`, '_blank')}
                    >
                      View on Explorer
                    </button>
                  </Tooltip>
                </div>
              </div>
              <div className="solana-button">
                <div className="Buy-content-heading">
                  <h3>Buy Now with a Debit Card or Crypto!</h3>
                </div>
                <div className="product-images">
                  <img src={phantom} alt="phantom"></img>
                  <img
                    src={solanaBuy}
                    className="solanabuyBTN"
                    alt="solanaBuy"
                  ></img>
                  <img src={visa} alt="visa"></img>
                </div>
                <Link to="/login">BUY NOW</Link>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container content-counter-sec">
        <div className="row">
          <div className="tokenomics-section">
            <h2 className="title_faq">Tokenomics</h2>
            <br />
            <span className="dummy-content">
              The Los Angeles Loyals ($LAL) tokenomics are structured to ensure
              long-term growth and sustainability within the ecosystem. Out of
              the 1 billion total supply, 700 million $LAL will be in
              circulating supply, allowing the community to trade and engage
              with the project. 160 million $LAL is allocated to the development
              team, ensuring continuous innovation, platform improvements, and
              security enhancements. An additional 140 million $LAL is reserved
              for marketing, partnerships, airdrops, and community events,
              driving adoption, engagement, and promotional initiatives.
            </span>

            <div className="container mt-4 tokonomies-section">
              <div className="container graphs-section">
                <div className="row card-row">
                  <div className="col-md-8 cards-sections">
                    <div className="row">
                      <div className="heading-card">
                        <h5>Total Allocation</h5>
                      </div>
                    </div>
                    <div className="content-section">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="donut-section-image">
                          <img className="donut-image" src={leftBar}></img>
                          </div>
                        </div>
                        <div className="col-md-7 right-donut-sec">
                          <img src={rightBar}></img>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 cards-sections initial-card">
                    <div className="main-sec-card">
                      <div className="row">
                        <div className="rectangular-card">
                          <h6>Launch Price</h6>
                          <h6>$0.0005</h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="rectangular-card">
                          <h6>Initial Circulating Supply</h6>
                          <h6>700,000,000 LFCoin</h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="rectangular-card last-card">
                          <h6>
                            {" "}
                            1.5 million LFCoin can be purchased per wallet daily
                            for the first 30 days
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row card-row mt-4 mt-md-5">
                  <div className="col-md-12 cards-sections chart-card">
                    <div className="row">
                      <div className="heading-card">
                        <h5>Unlocked Amount (LFCoin)</h5>
                      </div>
                    </div>
                    <div className="content-section">
                      <img src={bar} alt="" />
                    </div>
                  </div>
                </div>
                <div className="row mt-4 mt-md-5">
                  <div className="col-md-12 cards-sections chart-card bar-chart-card developer-scheduler">
                    <div className="row">
                      <div className="heading-card">
                        <h5>Developer Unlock Scheduler</h5>
                      </div>
                    </div>
                    <div className="content-section">
                      <Graph />
                    </div>
                  </div>
                </div>
                <div className="row mt-4 mt-md-5">
                  <div className="heading-card">
                    <h5>Circulating Supply Breakdown (Quartely)</h5>
                  </div>
                  <div className="col-md-12 px-0 cards-sections">
                    <TableRecord />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 p-0">
          <div className="lend-cont-inner-in container">
            <p>
              <strong>Disclosure: </strong>
              LF Coin ($LAL) is a community-driven meme coin created to
              celebrate sports fandom and foster community engagement. LF Coin
              is not affiliated with the Los Angeles Lakers, the National
              Basketball Association (NBA), or any associated organizations. The
              project operates independently and is solely focused on building a
              decentralized community of sports enthusiasts. As a meme coin, LF
              Coin carries no intrinsic value and should not be considered an
              investment or security.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Content;
